import { render, staticRenderFns } from "./addReviewerDialog.vue?vue&type=template&id=fe72abe4&scoped=true"
import script from "./addReviewerDialog.vue?vue&type=script&lang=js"
export * from "./addReviewerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe72abe4",
  null
  
)

export default component.exports